import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';
import { TokenService } from '../../services';
import { Payrun } from './payrun.model';

@Injectable()
export class PayrunService {
  constructor(private http: HttpClient, private token: TokenService) {}

  get(): Observable<Payrun[]> {
    return this.http
      .get<{ data: Payrun[] }>(`${config.apiLocation}/v1/payruns`)
      .map(res => res.data);
  }

  /**
   * Download a payrun report
   *
   * @param payrunId
   * @return {Observable<string>}
   */
  downloadReportUrl(payrunId: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/payruns/${payrunId}/downloadReport?token=${token}`);
  }

  /**
   * Get an payrun's CSV download URL.
   *
   * @param {Invoice} invoice
   * @return {Observable<string>}
   */
  downloadCsvUrl(payrunId: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/payruns/${payrunId}/downloadCsv?token=${token}`);
  }

  /**
   * Download an aba file
   *
   * @param payrunId
   * @return {Observable<string>}
   */
  downloadAbaUrl(payrunId: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/payruns/${payrunId}/downloadAba?token=${token}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/payruns/payrun.service.ts